module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8003.f972b372.png";